import { render, staticRenderFns } from "./my-drawer.vue?vue&type=template&id=0addc239&scoped=true"
import script from "./my-drawer.vue?vue&type=script&lang=js"
export * from "./my-drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0addc239",
  null
  
)

export default component.exports